import { combineReducers } from "redux";


import Chats from "./chats/reducer";

export default combineReducers({

  Chats,
});
